import React from 'react';
import { useTranslation } from '../../../../context/LanguageContext';
import InputField from '../../../form/InputField';
import SelectField from '../../../form/SelectField';
import CheckboxField from '../../../form/CheckboxField';

const TableServiceTab = ({ settings, handleChange }) => {
    const { t, isRTL } = useTranslation();

    return (
        <div className="space-y-6">
            <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className={`text-lg font-semibold text-gray-800 mb-6 ${isRTL ? 'text-right' : 'text-left'}`}>
                    {t('admin.tableServiceSettings')}
                </h3>
                <div className="grid grid-cols-1 gap-6">
                    <CheckboxField
                        label={t('admin.enableTableService')}
                        checked={settings.table_service?.enabled || false}
                        onChange={(e) => handleChange('table_service', 'enabled', e.target.checked)}
                    />
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.serviceCharge')}
                            value={settings.table_service?.service_charge || 0}
                            type="number"
                            onChange={(e) => handleChange('table_service', 'service_charge', parseFloat(e.target.value))}
                        />
                        <SelectField
                            label={t('admin.chargeType')}
                            value={settings.table_service?.charge_type || 'percentage'}
                            onChange={(e) => handleChange('table_service', 'charge_type', e.target.value)}
                            options={[
                                { value: 'percentage', label: t('admin.percentage') },
                                { value: 'fixed', label: t('admin.fixed') }
                            ]}
                        />
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <InputField
                            label={t('admin.minOrderAmount')}
                            value={settings.table_service?.min_order_amount || 0}
                            type="number"
                            onChange={(e) => handleChange('table_service', 'min_order_amount', parseFloat(e.target.value))}
                        />
                        <InputField
                            label={t('admin.maxServiceCharge')}
                            value={settings.table_service?.max_service_charge || 0}
                            type="number"
                            onChange={(e) => handleChange('table_service', 'max_service_charge', parseFloat(e.target.value))}
                            helperText={t('admin.maxServiceChargeHelp')}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TableServiceTab;
